import { useEffect } from "react"
import { useSelector } from "react-redux"
import store from "~Shared/store"
import { setCurrentPage } from "~Shared/store/actions/tableConfig/tableConfigActions"
import { TablesEnum } from "~Shared/store/reducers/tableConfigReducer"
import { RootState } from "~Shared/store/rootState.interface"

export const useTableConfig = (table: TablesEnum) => useSelector(({ tableConfig }: RootState) => tableConfig[table]) || { currentPage: 1, itemsPerPage: 20, sorting: {} }

export const usePagingGuard = (table: TablesEnum, resources: Array<any>, totalDocs: number, currentPage: number) => {
    // if a page became empty (e.g. through deletion of resources), fetch the previous one
    useEffect(() => {
        if (resources.length === 0 && totalDocs > 0 && currentPage > 1) {
            store.dispatch(setCurrentPage(table, currentPage - 1))
        }
    }, [resources.length])
}
